import React, { useEffect } from 'react';

interface Props {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
    justifyContent: 'center', zIndex: 1100, padding: 24,
  },
  modal: {
    background: 'white', borderRadius: 12, maxWidth: 440, width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden',
  },
  body: { padding: '24px 24px 16px' },
  title: { fontSize: 18, fontWeight: 700, color: '#1a365d', margin: '0 0 8px' },
  message: { fontSize: 14, color: '#4a5568', margin: 0, lineHeight: 1.5 },
  actions: {
    display: 'flex', justifyContent: 'flex-end', gap: 10,
    padding: '12px 24px', background: '#f7fafc', borderTop: '1px solid #e2e8f0',
  },
  cancelBtn: {
    background: 'white', color: '#333', border: '1px solid #cbd5e0',
    padding: '8px 20px', borderRadius: 6, fontSize: 14, cursor: 'pointer',
  },
  confirmBtn: {
    color: 'white', border: 'none', padding: '8px 20px',
    borderRadius: 6, fontSize: 14, cursor: 'pointer', fontWeight: 600,
  },
};

export default function ConfirmModal({ open, title, message, confirmLabel, cancelLabel, danger, onConfirm, onCancel }: Props) {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div style={styles.overlay} onClick={onCancel}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.body}>
          <h3 style={styles.title}>{title}</h3>
          <p style={styles.message}>{message}</p>
        </div>
        <div style={styles.actions}>
          <button style={styles.cancelBtn} onClick={onCancel}>{cancelLabel || 'Cancel'}</button>
          <button
            style={{ ...styles.confirmBtn, background: danger ? '#e53e3e' : '#0078d4' }}
            onClick={onConfirm}
          >
            {confirmLabel || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
